import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

const Counter = ({ end, duration = 2000, suffix = '', prefix = '' }) => {
  const [count, setCount] = useState(0);
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });

  useEffect(() => {
    if (inView && typeof end === 'number' && !isNaN(end)) {
      let startTimestamp = null;
      let animationId = null;
      
      const step = (timestamp) => {
        try {
          if (!startTimestamp) startTimestamp = timestamp;
          const progress = Math.min((timestamp - startTimestamp) / duration, 1);
          
          // Improved easing function for smoother animation
          const easeOutQuart = 1 - Math.pow(1 - progress, 4);
          
          // Handle decimal values properly
          const currentCount = typeof end === 'number' && end % 1 !== 0 
            ? parseFloat((easeOutQuart * end).toFixed(1))
            : Math.floor(easeOutQuart * end);
          
          setCount(currentCount);
          
          if (progress < 1) {
            animationId = window.requestAnimationFrame(step);
          }
        } catch (error) {
          console.error('Counter animation error:', error);
          setCount(end);
        }
      };
      
      animationId = window.requestAnimationFrame(step);
      
      // Cleanup function to cancel animation if component unmounts
      return () => {
        if (animationId) {
          window.cancelAnimationFrame(animationId);
        }
      };
    } else if (inView) {
      // Fallback for invalid values
      setCount(end || 0);
    }
  }, [inView, end, duration]);

  return (
    <span ref={ref}>
      {prefix}{count}{suffix}
    </span>
  );
};

export default Counter;